import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';

function CampaignsAction(props) {
  const { showDuplicateDialog, showFolderSelector, onDelete } = props;
  const {
    id,
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!id || !Writer) {
    return null;
  }

  return (
    <div
      data-test="campaign-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="View Assignments">
        <Link
          data-test="location-copy-setting"
          to={`/campaigns/${id}/assignments?parent=/*`}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/assignment_icon.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </Link>
      </ToolTipIcon>

      <ToolTipIcon toolText="Delete Campaign">
        <button
          type="button"
          onClick={onDelete}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/delete_button.svg"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>

      <ToolTipIcon toolText="Move Campaign">
        <button
          type="button"
          onClick={showFolderSelector}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/paste_button.svg"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>

      <ToolTipIcon toolText="Duplicate Campaign">
        <button
          data-test="location-copy-setting"
          type="button"
          onClick={async () => {
            showDuplicateDialog();
          }}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/copy_button.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

CampaignsAction.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showFolderSelector: PropTypes.func.isRequired,
  showDuplicateDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CampaignsAction;
